
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from '@/hooks/use-user';
import { toast } from 'sonner';

export interface UserStore {
  id: string;
  user_id: string;
  store_name: string;
  cpf: string;
  full_name: string;
  contact_email: string;
  terms_accepted: boolean;
  created_at: string;
  updated_at: string;
}

export const useStore = () => {
  const { user } = useUser();
  const [store, setStore] = useState<UserStore | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchStore = async () => {
    if (!user?.id) return;

    try {
      const { data, error } = await supabase
        .from('user_stores')
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) throw error;
      setStore(data);
    } catch (error) {
      console.error('Error fetching store:', error);
      toast.error('Erro ao carregar dados da loja');
    } finally {
      setLoading(false);
    }
  };

  const createStore = async (storeData: {
    store_name: string;
    cpf: string;
    full_name: string;
    contact_email: string;
  }) => {
    if (!user?.id) throw new Error('User not authenticated');

    try {
      const { data, error } = await supabase
        .from('user_stores')
        .insert({
          user_id: user.id,
          ...storeData,
          terms_accepted: true,
        })
        .select()
        .single();

      if (error) throw error;
      setStore(data);
      toast.success('Loja criada com sucesso!');
      return data;
    } catch (error) {
      console.error('Error creating store:', error);
      toast.error('Erro ao criar loja');
      throw error;
    }
  };

  useEffect(() => {
    fetchStore();
  }, [user?.id]);

  return {
    store,
    loading,
    createStore,
    refetch: fetchStore,
  };
};
